import { render } from "./areaView.vue?vue&type=template&id=735e5ec0&scoped=true&ts=true"
import script from "./areaView.vue?vue&type=script&lang=ts&config=true"
export * from "./areaView.vue?vue&type=script&lang=ts&config=true"

import "./areaView.vue?vue&type=style&index=0&id=735e5ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e5ec0"]])

export default __exports__